import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 3337B267-94EC-426B-ABC9-5842F75B13B1
 * name arrow-up-bold-circle-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold-circle-outline.svg
 * tags
 * - Arrow 
 */
export const ArrowUpBoldCircleOutlineIcon = createSvgIcon(<><path d="M12,7L17,12H14V16H10V12H7L12,7M12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20Z" /></>, 'ArrowUpBoldCircleOutlineIcon');
export default ArrowUpBoldCircleOutlineIcon